<script>
	import { Col, Row, Button } from "@sveltestrap/sveltestrap";
	import { Splide, SplideSlide } from "@splidejs/svelte-splide";
	import { convert, formatSummary } from "../../../../services/helpers";
	import { onDestroy, onMount } from "svelte";
	import client from "../../../../services/client";
	import {
		loadingSort,
		imageLightbox,
		issueNumber,
		carIssueOpen,
		carIssueData,
		resolveIssue,
		isResolvingIssue,
	} from "../../../../store/store";
	import FilterSortIssue from "../../../../components/FilterForm/FilterSortIssue.svelte";
	import IssueTable from "./IssueTable.svelte";
	//lightbox with image
	import Lightbox from "../../../../components/Lightbox/Lightbox.svelte";
	import LoaderContainerSort from "../../../../components/Loader/LoaderContainerSort.svelte";

	export let options = [];
	export let detailData;
	export let reportSection;

	let data = [];
	let load = false;
	let modalOpen = false;
	let imageShowingIndex = 0;
	let filteredData = [];
	let searchInput;

	const fetchIssues = async (
		sortBy = "issue_no",
		damageArea,
		sortDir = "desc",
		issueNo
	) => {
		try {
			loadingSort.set(true);
			let sortQuery = `&ReportSection=${reportSection}&Page=1&Size=20&SortCol=${sortBy}&SortDir=${sortDir}`;
			if (damageArea) {
				sortQuery += `&damageType=${damageArea.toLowerCase()}`;
			}
			if (issueNo) {
				sortQuery += `&issueNo=${issueNo}`;
			}
			const issues = await client(
				`/v0/Cmm/active-approved-issue?PlateNumber=${detailData.plateNumber}${sortQuery}`,
				{
					method: "GET",
					version: "Tasking",
				}
			);
			data = issues.data.vehicleIssues;
			loadingSort.set(false);
		} catch (error) {
			loadingSort.set(false);
			console.log(error);
		}
	};

	const handleImgClick = (i) => {
		let img = [];
		imageLightbox.set(
			data[i].imageUrls.map((slide) => {
				img.push(slide);
				return img;
			})
		);
		imageShowingIndex = Number(i);
		modalOpen = true;
	};

	const handleResolve = async (issueId) => {
		try {
			load = true;
			const res = await client(`/api/Issue/v2/ResolveIssue`, {
				method: "POST",
				version: "Vehicle",
				data: {
					issueId,
				},
			});
			resolveIssue.set({
				issueId,
				isResolving: true,
			});
			isResolvingIssue.set(true);
			fetchDriveIssues();

			load = false;
		} catch (error) {
			console.log(error);
			load = false;
		}
	};

	onMount(() => {
		fetchIssues();
	});

	onDestroy(() => {
		carIssueOpen.set(false);
		issueNumber.set("");
		carIssueData.set("");
		resolveIssue.set({
			issueId: "",
			isResolving: false,
		});
		isResolvingIssue.set(false);
	});
</script>

{#if $carIssueOpen}
	<LoaderContainerSort>
		<Row class="issue-detail-resolve">
			<Col xs={12}>
				{#if modalOpen}
					<Lightbox
						on:click={() => (modalOpen = false)}
						{imageShowingIndex}
					/>
				{/if}
				<Row class="my-2">
					<Splide {options} aria-label="My Favorite Images">
						{#each $carIssueData.imageUrls as slide, index}
							<SplideSlide>
								<img
									src={slide}
									alt="alt"
									style="width: 100%; height:260px; object-fit: cover; "
									class="link"
									on:click={() => handleImgClick(index)}
								/>
							</SplideSlide>
						{/each}
					</Splide>
				</Row>
			</Col>
			<Col xs={12} class="my-2">
				<Col xxl={6} class="my-4">
					<Row class="my-3">
						<Col><span>Status</span></Col>
						<Col>
							{#if $carIssueData.status === "Unresolved"}
								<p class="status-bar-detail status-bar-3">
									Unresolved
								</p>
							{:else if $carIssueData.status === "Resolved"}
								<p class="status-bar-detail status-bar-1">
									Resolved
								</p>
							{:else if $carIssueData.status === "Resolving"}
								<p class="status-bar status-bar-2">Resolving</p>
							{:else if $carIssueData.status === "Review"}
								<p class="status-bar status-bar-2">Review</p>
							{/if}
						</Col>
					</Row>
					<Row class="my-3">
						<Col><span>Issue No.</span></Col>
						<Col>
							<b> {$carIssueData.issueNo}</b>
						</Col>
					</Row>
					<Row class="my-3">
						<Col><span>Date Reported</span></Col>
						<Col>
							<b>
								{convert($carIssueData.dateReported)}
							</b>
						</Col>
					</Row>
					<Row class="my-3">
						<Col><span>Summary</span></Col>
						<Col>
							<b> {formatSummary($carIssueData.summary)}</b>
						</Col>
					</Row>
				</Col>
			</Col>
			<Col xs={12}>
				<Row class="my-2">
					{#if load}
						<div class="d-flex justify-content-end pe-5">
							<Button
								class="customButton primary-blue"
								type="button"
								disabled
							>
								<output
									class="spinner-grow spinner-grow-sm"
									aria-hidden="true"
								/>
								Loading...
							</Button>
						</div>
					{:else if $carIssueData.status === "Pending"}
						<span class="d-flex justify-content-end pe-5">
							<Button
								on:click={() =>
									handleResolve($carIssueData.issueId)}
								class="customButton primary-blue "
								>Resolve</Button
							>
						</span>
					{/if}
				</Row>
			</Col>
		</Row>
	</LoaderContainerSort>
{/if}
<FilterSortIssue handleSortBy={fetchIssues} />
<IssueTable {data} {filteredData} {searchInput} />

<style>
	:global(.issue-detail-resolve) {
		border: 0.5px solid rgb(206, 200, 200);
		margin-left: 0px !important;
		border-radius: 5px;
		padding: 7px 7px 7px 7px;
		overflow: hidden;
		/* box-shadow: 0px 0px 1px 1px rgba(154, 146, 146, 0.5); */
	}

	.link:hover {
		text-decoration: underline;
		filter: brightness(30%);
	}
</style>
